module.exports = __webpack_public_path__ + "et.c7887990.svg";